import dayjs from "dayjs";

/**
 * Format a date/time value to a string
 * @param {string|number|Date|dayjs.Dayjs} date - The date value to format
 * @param {string} format - The format string (default: "YYYY/MM/DD HH:mm:ss")
 * @returns {string} Formatted date/time string
 */
export const formatDateTime = (date, format = "YYYY/MM/DD HH:mm:ss") => {
  if (date == null || date === undefined) {
    return dayjs().format(format);
  }
  return dayjs(date).format(format);
};

/**
 * Format a date value to a string (date only, no time)
 * @param {string|number|Date|dayjs.Dayjs} date - The date value to format
 * @param {string} format - The format string (default: "YYYY/MM/DD")
 * @returns {string} Formatted date string
 */
export const formatDate = (date, format = "YYYY/MM/DD") => {
  if (date == null || date === undefined) {
    return dayjs().format(format);
  }
  return dayjs(date).format(format);
};

